module.exports = "<div *ngIf=\"route\">\n\n\n\n</div>\nshuttle works\n"